"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitedNationsMarsInitiative = void 0;
const Card_1 = require("../../Card");
const Tags_1 = require("../../Tags");
const CardName_1 = require("../../../CardName");
const PartyHooks_1 = require("../../../turmoil/parties/PartyHooks");
const PartyName_1 = require("../../../turmoil/parties/PartyName");
const constants_1 = require("../../../constants");
const CardType_1 = require("../../CardType");
const CardRenderer_1 = require("../../render/CardRenderer");
const RedsPolicy_1 = require("../../../turmoil/RedsPolicy");
const Units_1 = require("../../../Units");
class UnitedNationsMarsInitiative extends Card_1.Card {
    constructor() {
        super({
            cardType: CardType_1.CardType.CORPORATION,
            name: CardName_1.CardName.UNITED_NATIONS_MARS_INITIATIVE,
            tags: [Tags_1.Tags.EARTH],
            startingMegaCredits: 40,
            metadata: {
                cardNumber: 'R32',
                description: 'You start with 40 M€.',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.br.br.br;
                    b.empty().nbsp().nbsp().nbsp().nbsp().megacredits(40);
                    b.corpBox('action', (ce) => {
                        ce.action('If your Terraform Rating was raised this generation, you may pay 3 M€ to raise it 1 step more.', (eb) => {
                            eb.megacredits(3).startAction.tr(1).asterix();
                        });
                    });
                }),
            },
        });
    }
    play() {
        return undefined;
    }
    canAct(player) {
        const hasIncreasedTR = player.hasIncreasedTerraformRatingThisGeneration;
        const redsAreRuling = PartyHooks_1.PartyHooks.shouldApplyPolicy(player, PartyName_1.PartyName.REDS);
        const actionCost = 3;
        if (!hasIncreasedTR)
            return false;
        Card_1.Card.setRedsActionWarningText(player, 1, this, redsAreRuling);
        if (redsAreRuling) {
            this.reserveUnits = Units_1.Units.adjustUnits(this.reserveUnits, { megacredits: constants_1.REDS_RULING_POLICY_COST });
            const actionDetails = this.getActionDetails();
            this.howToAffordReds = RedsPolicy_1.RedsPolicy.canAffordRedsPolicy(player, player.game, actionDetails);
            if (this.howToAffordReds.mustSpendAtMost !== undefined || this.howToAffordReds.bonusMCFromPlay !== undefined) {
                this.reserveUnits = Units_1.Units.maybeAdjustReservedMegacredits(player, this.reserveUnits, this.howToAffordReds);
            }
            return this.howToAffordReds.canAfford;
        }
        return player.canAfford(actionCost);
    }
    action(player) {
        player.payMegacreditsDeferred(3, 'Select how to pay for UNMI action.', () => player.increaseTerraformRatingSteps(1));
        return undefined;
    }
    getActionDetails() {
        return new RedsPolicy_1.ActionDetails({ cost: 3, TRIncrease: 1 });
    }
}
exports.UnitedNationsMarsInitiative = UnitedNationsMarsInitiative;
//# sourceMappingURL=UnitedNationsMarsInitiative.js.map